import { render, staticRenderFns } from "./index-customer.vue?vue&type=template&id=cd5dfe0a&"
import script from "./index-customer.vue?vue&type=script&lang=js&"
export * from "./index-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports